"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDialogProps = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sds_1 = require("@squiz/sds");
const components_1 = require("../../components");
const ModalFooter_1 = require("../../components/molecules/ModalFooter/ModalFooter");
const icons_1 = require("../../icons");
const createDialogProps = (content, contentTool, onInsertAfter, onReplace) => {
    const dialogProps = {
        buttonKeys: ['btn-cancel', 'btn-insert-after', 'btn-replace'],
        classes: ['dxp-ctm-dialog'],
        dialogContent: {
            renderContent: (dialogContentProps) => {
                return ((0, jsx_runtime_1.jsx)(components_1.ModalContent, { content: content, contentTool: contentTool, dialogContentProps: dialogContentProps, onInsertAfter: onInsertAfter, onReplace: onReplace }));
            },
        },
        dialogSize: sds_1.DIALOG_SIZE_XL,
        footer: (0, jsx_runtime_1.jsx)(ModalFooter_1.ModalFooter, { contentTool: contentTool }),
        heading: `Rewrite content to ... ${contentTool.name}`,
        icon: icons_1.ICON_DXP_AI,
        showFullScreenButton: true,
    };
    return dialogProps;
};
exports.createDialogProps = createDialogProps;
